import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LogoutRequest, getUser } from "../../api/userApi";
import { dispatchAlertError } from "../../app/godispatch";
import { logout, selectUserTheName } from "../../app/user/userSlice";
import UserLayout from "../component/UserLayout";
import './HomeUserPage.css';
import PasswordModal from "./PasswordModal";

export default function HomeUser() {
    document.title = '用户信息'
    const userTheName = useSelector(selectUserTheName)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const passowrdModalRef = useRef(null);
    const [userInfo, setUserinfo] = useState({
        name: userTheName,
        expireTime: null
    })

    const goLogout = async () => {
        await LogoutRequest()
            .catch((e) => {
                console.log(e)
            })
            .finally(() => {
                dispatch(logout());
                window.location.href = '/';
            })
    }

    useEffect(() => {
        getUser()
            .then((res) => {
                setUserinfo(res.data)
            })
            .catch(e => {
                dispatchAlertError('获取用户信息失败')
            })
    }, [])

    const goChangePassword = () => {
        passowrdModalRef.current.showMe();
    }

    const goMySubscription = () => {
        navigate('/user/subscriptions')
    }

    const goMyFunction = () => {
        navigate('/user/tools')
    }

    return (
        <UserLayout>
            <div className="allArea">
                <Container fluid>
                    <Row className="ellipseStyle">
                        <Col>
                            {/* https://stackoverflow.com/a/54132191/8936864 */}
                            <Row className="userInfoRow g-0">
                                <Col xs={5} md={5} className="d-flex justify-content-end align-items-center">
                                    <span className="userInfoText">欢迎</span>
                                </Col>
                                <Col xs={1} md={1}></Col>
                                <Col xs={6} md={6} className="d-flex justify-content-start align-items-center">
                                    <span className="userInfoText">{userInfo.name}</span>
                                </Col>
                            </Row>
                            <Row className="userInfoRow">
                                <Col></Col>
                                <Col xs={8} md={6} className="d-flex justify-content-start align-items-center">
                                    {userInfo.expireTime && <span>账户可用至{moment.utc(userInfo.expireTime).local().format('YYYY-MM-DD')}</span>}
                                    {!userInfo.expireTime && <span>账户不可用</span>}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
                <Container>
                    <Row className="userOptArea">
                        <Col>
                            <Row className="userOptText userOptItem" onClick={goChangePassword}>
                                <Col xs={1}></Col>
                                <Col>修改密码</Col>
                                <Col className="d-flex justify-content-end align-items-center">
                                    <img className="imageArrow" src='/public-static/icons8-arrow-right.png' alt=""></img>
                                </Col>
                            </Row>
                            <Row className="userOptItemDivider"></Row>
                            <Row className="userOptText userOptItem" onClick={goMySubscription}>
                                <Col xs={1}></Col>
                                <Col>我的订阅</Col>
                                <Col className="d-flex justify-content-end align-items-center">
                                    <img className="imageArrow" src='/public-static/icons8-arrow-right.png' alt=""></img>
                                </Col>
                            </Row>
                            <Row className="userOptItemDivider"></Row>
                            <Row className="userOptText userOptItem" onClick={goMyFunction}>
                                <Col xs={1}></Col>
                                <Col>我的工具</Col>
                                <Col className="d-flex justify-content-end align-items-center">
                                    <img className="imageArrow" src='/public-static/icons8-arrow-right.png' alt=""></img>
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                    <Row className="exitBtnArea">
                        <Button variant="outline-danger" size="lg" onClick={goLogout}>退出登录</Button>
                    </Row>
                </Container>
            </div>
            <PasswordModal ref={passowrdModalRef} />
        </UserLayout>
    )
}